/*  Copyright 2021 Sebastian Spautz

    This File is Part of "AiS Online Forms".

    "AiS Online Forms" is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    any later version.
    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.
    You should have received a copy of the GNU General Public License
    along with this program.  If not, see http://www.gnu.org/licenses/.
*/

import * as main from '../scripts/main.js'

/** Main modul for the Aces in Space Charactersheet
  * @module acesinspace.1.gang
  */

window.sitforms = window.sitforms || {}
window.sitforms.basepath = '../'

/**
 * Verändert das Formular in abhängigkgiet vom Playbook der Gang.
 * 1. Ändert Label und Placeholder des Free-Aspekts
 * @param {String} type Der Name des Playbooks der Gang.
 * @return {undefined} nothing
 */
function manipulateFormByType (type) {
  const freeAspectInput = document.getElementById('aspects_free')
  const freeAspectLabel = freeAspectInput.parentElement.querySelector('label')
  const freeAspectLabelDefault = freeAspectLabel.textContent

  const gangType = document.querySelector(`option[value='${type}']`)
  if (gangType) {
    freeAspectLabel.textContent = gangType.dataset.freeaspect
    freeAspectInput.placeholder = gangType.dataset.freeaspectplaceholder
  } else {
    freeAspectLabel.textContent = freeAspectLabelDefault
    freeAspectInput.placeholder = ''
  }
}

/**
 * Initialisiert das dynamische Ändern des Formulars in Abhängigkeit des
 * Gangtypen.
 * @returns {undefined} nothing
 */
function initType () {
  document.getElementById('type').addEventListener('change', (event) => {
    manipulateFormByType(event.target.value)
  })
}

document.addEventListener('DOMContentLoaded', function (/* event */) {
  initType()

  // reinitieren des Formulars nach dem Laden eines Dokuments
  document.querySelector('main').addEventListener('loadedSheet', function (event) {
    manipulateFormByType(document.getElementById('gangbook').value)
  })
})
